export default class DataFilter {
    constructor() {
        this.dataFilter = document.querySelector('.dataFilter');

        if (!this.dataFilter) return;

        this.bindEvents();
        this.bindProfessionalsSearch();
        this.scrollToProfessionalsSearch();
    }

    bindEvents() {
        this.toggle('.btnOpenDataFilter', true);
        this.toggle('.btnCloseDataFilter', false);
    }

    toggle(selector, state) {
        document.querySelectorAll(selector).forEach(btn => {
            btn.addEventListener('click', () => {
                this.dataFilter.classList.toggle('active', state);
            });
        });
    }

    bindProfessionalsSearch() {
        const form = document.querySelector('.formProfessionalsSearch');
        const input = form?.querySelector('input[name="s"]');
        const clearButton = form?.querySelector('.search-clear');

        if (!form || !input) return;

        input.addEventListener('input', () => {
            input.setCustomValidity('');
            const hasValue = input.value.length > 0;
            clearButton?.classList.toggle('hidden', !hasValue);
            clearButton?.classList.toggle('flex', hasValue);
        });

        form.addEventListener('submit', (event) => {
            if (input.value.trim().length >= 3) {
                input.setCustomValidity('');
                return;
            }

            event.preventDefault();
            input.setCustomValidity(form.dataset.minLengthMessage);
            input.reportValidity();
        });

        clearButton?.addEventListener('click', () => {
            input.value = '';
            input.setCustomValidity('');
            form.submit();
        });
    }

    scrollToProfessionalsSearch() {
        const section = document.querySelector('[data-scroll-on-search="true"]');

        if (!section) return;

        requestAnimationFrame(() => {
            section.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
    }
}

new DataFilter();
